module.exports = __webpack_public_path__ + "static/media/excellent-icon.d15f0fc2.svg";